import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Box, Autocomplete, TextField } from "@mui/material";
import { Typography } from "antd";
import styles from "./index.module.css";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../../../actions/user.actions";
import { useCurrentUser } from '../../../hooks/useCurrentUser';

export default function CreateProduct(props) {
  const {
    productCategory,
    openDialog,
    setOpenDialog,
    roi,
    includeBPI,
    deductBroken,
    addBrokenToFirstEmi,
    frequency,
    daysConversion,
    pfType,
    pfTypeValue,
    advanceEMIs,
    apr,
    mode,
    flatInterestCalculation,
    flatInterestType,
    tenure
  } = props;

  const [instituteList, setInstituteList] = useState([]);
  const [instituteCode, setInstituteCode] = useState(null);
  const [instituteID, setInstituteID] = useState(null);
  const [instituteName, setInstituteName] = useState("");
  const [productName, setProductName] = useState(null);
  const [selectedInstitutes, setSelectedInstitutes] = useState([]); 
  const [instituteIds, setInstituteIds] = useState([]);
  const [loanType, setLoanType] = useState(null);
  const [loanTypeCode, setLoanTypeCode] = useState("");
  const [advanceEMIValue, setAdvanceEMIValue] = useState(advanceEMIs);
  const productCode = "ST";
  const loanTypeOptions = [
    { label: "Education Loan", code: "EL" },
    { label: "Personal Loan", code: "PL" },
    { label: "Business Loan", code: "BL" },
    { label: "Others", code: "OT" },
  ];
  const dispatch = useDispatch();
  const decode = useCurrentUser();
  const user = null;
  const instituteState = useSelector(
    (state) => state?.GETINSTITUTE?.res?.data?.data
  );

  const createProductState = useSelector(
    (state) => state?.CREATEPRODUCT?.res?.data?.message
  );
  useEffect(() => {
    if (createProductState === "Successful") {
      alert("Product Added Successfully.");
      setOpenDialog(false);
      setTimeout(() => window.location.reload(true), 1000);
    }
  }, [createProductState]);

  const getInsituteInfo = (text) => {
    setInstituteName(text);
    const urlGetInstitute = `/institute/info/name?name=${text}`;

    if (text.length >= 4) {
      dispatch(userActions.getInstituteInfo(urlGetInstitute, user));
      setInstituteList(instituteState);
    } else {
      setInstituteList([]);
    }
  };
  const handleInstituteDetails = (data) => {
    setInstituteCode(data?.code);
    setInstituteID(data?.id);
    setInstituteList(null);
  };

  const formatTenure = (tenureVal) => {
    if (tenureVal === "Dynamic") return "DY";
    if (!tenureVal) return "00";
    return String(tenureVal).padStart(2, "0");
  };

  const formatAdvanceEMI = (advance) => {
    if (advance === 0) return "0";
    if (!advance) return "0";
    return String(advance);
  };

  const formatPFValue = (pfValue) => {
    if (!pfValue) return "00";
    return String(pfValue).replace(".", "").slice(0, 2);
  };

  const autoProductCode = [
    loanTypeCode || "XX",
    productCode || "XXX",
    formatTenure(tenure),
    formatAdvanceEMI(advanceEMIValue),
    formatPFValue(pfTypeValue),
  ].join("");

  const handleCreateProduct = async () => {
    const isFeemonk = decode?.clientId === '' || decode?.clientId === 'd428c3d0-b5c7-4e9c-857b-e76c1cb8248c';
    const isValid = isFeemonk ? (selectedInstitutes.length === 0) : (!productName || !instituteCode);
    
    if (isValid) {
      alert("Loan/Product Name Missing, Please check");
    } else {
      const productData = {
        name: (decode?.clientId === '' || decode?.clientId === 'd428c3d0-b5c7-4e9c-857b-e76c1cb8248c') 
          ? `${autoProductCode}`
          : `${instituteCode}${productCode}${roi}${productName}`,
        tenure: decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361'? 0: tenure,
        instituteId: (decode?.clientId === '' || decode?.clientId === 'd428c3d0-b5c7-4e9c-857b-e76c1cb8248c') ? instituteIds : instituteID,
        facilityType: 2,
        irr: apr * 0.01,
        discountedInterestPercentage: 0,
        instituteShare: 0,
        studentShare: 100,
        discountedInterestType: 1,
        standardInterestPercentage: roi * 0.01,
        standardInterestType:  mode === "basic" ? 1 : mode === "flat" ? 2 : null,
        processingfeeType: pfType === "Percentage" ? 2 : 1,
        limitAmount: 0,
        processingfeeValue:
          pfType === "Percentage" ? pfTypeValue * 0.01 : pfTypeValue,
        processingfeeValueGST:
          pfType === "Flat" ? pfTypeValue * 0.18 : pfTypeValue * 0.01 * 0.18,
        processingfeValueIncludingGST:
          pfType === "Flat"
            ? pfTypeValue - -pfTypeValue * 0.18
            : pfTypeValue * 0.01 - -(pfTypeValue * 0.01) * 0.18,
        fldgApplicable: false,
        fldgPercentage: 0,
        fldgReturnMonth: 0,
        advanceEmis: advanceEMIs,
        disbursementMonth1Percentage: 100,
        disbursementMonth2Percentage: 0,
        disbursementMonth3Percentage: 0,
        disbursementMonth4Percentage: 0,
        disbursementMonth1: 0,
        disbursementMonth2: 0,
        disbursementMonth3: 0,
        disbursementMonth4: 0,
        createdBy: decode?.display_name,
        frequency: frequency,
        daysConversion: daysConversion,
        brokenPeriodInterest: includeBPI,
        deductBroken: deductBroken,
        addbrokenInterestToFirstemi: addBrokenToFirstEmi,
        tenureType:flatInterestType===false?2:1,
      };

      const createProductUrl = `/products/create`;
      dispatch(userActions.createProduct(createProductUrl, productData,user));
    }
  };

  return (
    <Dialog
      open={openDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" className={styles.dialogTitle}>
        <Typography className={styles.titleName}>
          {"Product Summary"}
        </Typography>
        <ClearIcon
          onClick={() => setOpenDialog(false)}
          sx={{ cursor: "pointer" }}
        />
      </DialogTitle>

      <DialogContent
        className={styles.dialogContent}
        sx={{ minWidth: 500, marginTop: 1 }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            mb: 1,
            gap: 2,
            width: "100%",
          }}
        >
          {(decode?.clientId === '' || decode?.clientId === 'd428c3d0-b5c7-4e9c-857b-e76c1cb8248c') ? (
            <Box sx={{ display: "flex", gap: "1em", alignItems: "flex-start", width: "100%" }}>
              <Autocomplete
                multiple
                size="small"
                options={(instituteList || []).map((item) => ({
                  label: item?.brandName || "Unknown",
                  ...item,
                }))}
                value={selectedInstitutes}
                filterSelectedOptions
                onChange={(event, newValue) => {
                  setSelectedInstitutes(newValue);
                  const ids = newValue.map((item) => item.id);
                  setInstituteIds(ids);
                }}
                onInputChange={(event, value) => getInsituteInfo(value)}
                sx={{ width: "18em" }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Institute Name"
                    sx={{ minWidth: 200 }}
                  />
                )}
              />
              <Autocomplete
                size="small"
                options={loanTypeOptions}
                getOptionLabel={(option) => option.label}
                value={loanType}
                onChange={(e, value) => {
                  setLoanType(value);
                  setLoanTypeCode(value?.code || "");
                }}
                sx={{ width: "14em" }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Loan Type"
                    sx={{ minWidth: 180 }}
                  />
                )}
              />
            </Box>
          ) : (
            <Autocomplete
              sx={{
                "& .MuiPopper-root": { fontFamily: "Outfit" },
                width: "15em",
              }}
              size="small"
              value={instituteName}
              options={(instituteList || []).map((item) => ({
                label: item?.brandName || "Unknown",
                ...item,
              }))}
              onChange={(event, selectedItem) =>
                handleInstituteDetails(selectedItem)
              }
              onInputChange={(event, value) => getInsituteInfo(value)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={"Enter Loan Type"}
                  InputLabelProps={{
                    sx: {
                      fontFamily: "Outfit",
                      borderRadius: "5px",
                      fontSize: "16px",
                    },
                  }}
                  sx={{
                    mb: 2,
                    marginTop: "10px",
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#707C8B",
                      },
                      "&:hover fieldset": {
                        borderColor: "#707C8B",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#d32028",
                      },
                      "& .MuiOutlinedInput-input": {
                        fontFamily: "Outfit",
                        fontWeight: "bold",
                      },
                    },
                  }}
                />
              )}
            />
          )}
          <Box
            sx={{ display: "flex", alignItems: "center", marginTop: "-5px" }}
          >
            <span
              style={{
                color: "white",
                backgroundColor: "#d32028",
                borderRadius: "5px",
                padding: "0px 5px 0px 5px",
                boxShadow: "0px 0px 1px 1px #D0D0D0",
                fontWeight: "bold",
                fontFamily: "Outfit",
              }}
            >
              {(decode?.clientId === '' || decode?.clientId === 'd428c3d0-b5c7-4e9c-857b-e76c1cb8248c') ? autoProductCode : `${instituteCode}${productCode}${roi}`}
            </span>

            {/* Product Name Input */}
            {(decode?.clientId === '' || decode?.clientId === 'd428c3d0-b5c7-4e9c-857b-e76c1cb8248c')?null:(
             <TextField
              label="Product Name"
              variant="outlined"
              onChange={(e) => setProductName(e.target.value)}
              size="small"
              sx={{
                width: "180px",
                fontFamily: "Outfit",
                "& .MuiOutlinedInput-root": {
                  fontFamily: "Outfit",
                  "& fieldset": {
                    borderColor: "#707C8B",
                  },
                  "&:hover fieldset": {
                    borderColor: "#707C8B",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#d32028",
                  },
                },
                "& .MuiInputLabel-root": {
                  fontFamily: "Outfit",
                  fontSize: "16px",
                },
                "& .MuiOutlinedInput-input": {
                  fontFamily: "Outfit",
                  fontWeight: "bold",
                },
              }}
            />
            )}
            
          </Box>
        </Box>
        <Box className={styles.card}>
          <Typography className={styles.title}>Category</Typography>
          <Typography className={styles.titleValue}>
            {productCategory}
          </Typography>
        </Box>
        <Box className={styles.card}>
          <Typography className={styles.title}>Conversion</Typography>
          <Typography className={styles.titleValue}>
            {`${daysConversion} Days`}
          </Typography>
        </Box>
        <Box className={styles.card}>
          <Typography className={styles.title}>ROI</Typography>
          <Typography className={styles.titleValue}>{`${roi}%`}</Typography>
        </Box>
        <Box className={styles.card}>
          <Typography className={styles.title}>APR</Typography>
          <Typography className={styles.titleValue}>{`${apr}%`}</Typography>
        </Box>
        <Box className={styles.card}>
          <Typography className={styles.title}>Fequency</Typography>
          <Typography className={styles.titleValue}>{frequency}</Typography>
        </Box>
        <Box className={styles.card}>
          <Typography className={styles.title}>ProcessingFee</Typography>
          <Typography className={styles.titleValue}>{`${pfTypeValue}${
            pfType === "Percentage" ? "%" : "₹"
          }`}</Typography>
        </Box>
        <Box className={styles.card}>
          <Typography className={styles.title}>Advance EMIs</Typography>
          <Typography className={styles.titleValue}>{advanceEMIs}</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            alignItems: "center",
            gap: "20px",
            marginTop: 1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              width: "50%",
            }}
          >
            <Typography className={styles.title}>
              Broken Period Interest
            </Typography>
            <Typography className={styles.titleValue}>
              {includeBPI ? "Yes" : "No"}
              {includeBPI ? (
                <CheckIcon sx={{ color: "#00aa00" }} />
              ) : (
                <ClearIcon sx={{ color: "#D32028" }} />
              )}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              width: "50%",
            }}
          >
            <Typography className={styles.title}>Deduct Broken</Typography>
            <Typography className={styles.titleValue}>
              {deductBroken ? "Yes" : "No"}
              {deductBroken ? (
                <CheckIcon sx={{ color: "#00aa00" }} />
              ) : (
                <ClearIcon sx={{ color: "#D32028" }} />
              )}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              width: "50%",
            }}
          >
            <Typography className={styles.title}>Broken To FirstEmi</Typography>
            <Typography className={styles.titleValue}>
              {addBrokenToFirstEmi ? "Yes" : "No"}
              {addBrokenToFirstEmi ? (
                <CheckIcon sx={{ color: "#00aa00" }} />
              ) : (
                <ClearIcon sx={{ color: "#D32028" }} />
              )}
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      <Button className={styles.createProductBtn} onClick={handleCreateProduct}>
        Create Product
      </Button>
    </Dialog>
  );
}
